import moment from "moment";

const columns = [
  { Header: "#", accessor: "#", width: "5%", align: "left" },
  { Header: "Date", accessor: "Date", align: "left" },
  { Header: "Time", accessor: "Time", align: "left" },
  { Header: "ID", accessor: "ID", align: "left" },
  { Header: "Name", accessor: "Name", align: "left" },
  { Header: "Device", accessor: "Device", align: "left" },
  { Header: "Milk", accessor: "Milk", align: "left" },
  { Header: "Sample", accessor: "Sample", align: "left" },
  { Header: "Cells per ml", accessor: "Cells per ml", align: "left" },
  { Header: "Avg Size um", accessor: "Avg Size um", align: "left" },
];

export default function somaticCellsTableData(data, startDate = null, endDate = null) {
  const measurements = Object.values(data || {})
    .flat()
    .filter((item) => {
      if (!startDate || !endDate) return true;
      const itemDate = moment(item.Date, "DD.MM.YY");
      return itemDate.isBetween(moment(startDate), moment(endDate), "day", "[]");
    });

  const getRows = () => {
    if (!measurements || !measurements.length) return [];
    return [...measurements].reverse().reduce((accum, item, i) => {
      accum.push({
        "#": ++i,
        Date: item.Date || "N/A",
        Time: item.Time || "N/A",
        ID: item.ID || "N/A",
        Name: item.Name || "N/A",
        Device: item.Device || "N/A",
        Milk: item.Milk || "N/A",
        Sample: item.Sample || "N/A",
        "Cells per ml": item["Cells per ml"] || "N/A",
        "Avg Size um": item["Avg.Size um"] || "N/A",
      });
      return accum;
    }, []);
  };

  return {
    columns,
    rows: getRows(),
  };
}
